/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import type { Logger } from '@feature-hub/logger';
import { getConsumptionsAndEmissionsWithIdentifiers } from '@oneaudi/feature-app-utils';
import type {
  ConsumptionsAndEmissions,
  VueFormatterServiceInterfaceV1,
} from '@oneaudi/vue-formatter-service';
import type { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import flatten from 'lodash.flatten';
import uniq from 'lodash.uniq';
import type { Content } from '../EditorContentTypes';

export function getUniqueWltpKeys(content: Content) {
  return uniq([
    ...(content.topModule?.legalData?.wltpKeys || []),
    ...flatten(content.additionalModules.map(({ legalData }) => legalData?.wltpKeys || [])),
  ]);
}

export async function getConsumptionsAndEmissions(
  content: Content,
  vueFormatterService: VueFormatterServiceInterfaceV1,
  localeService: LocaleServiceV1,
  logger?: Logger,
): Promise<Record<string, ConsumptionsAndEmissions>> {
  const uniqueWltpKeys = getUniqueWltpKeys(content);
  const caeData = await getConsumptionsAndEmissionsWithIdentifiers(
    uniqueWltpKeys,
    vueFormatterService,
    localeService,
    logger,
  );
  return caeData;
}
